import { fg } from '@atlaskit/platform-feature-flags';

import {
	COLLECTION_TYPE_SERVICE,
	COLLECTION_TYPE_TEAMWORK,
	type CollectionType,
} from '../common/constants';
import type { Product } from '../types';

export const getProductCollection = (
	product: Product,
): { collectionType: CollectionType; isEnabled: boolean } | undefined => {
	switch (product) {
		case 'jira-service-management':
			return { collectionType: COLLECTION_TYPE_SERVICE, isEnabled: fg('servco-xflow-ga') };
		case 'jira':
		case 'confluence':
			return {
				collectionType: COLLECTION_TYPE_TEAMWORK,
				isEnabled: fg('teamwork_collection_ea_modal'),
			};
		default:
			return undefined;
	}
};
